import React from 'react'
import {Flex} from '/app/src/component';
import style from './style.css'

import Theme from '/app/src/theme';
import SVG from 'react-inlinesvg';

export default class Post extends React.Component {
    render() {
        const {date, text, rating} = this.props
        const emoji = rating === 1 ?
            <SVG style={{'fill': Theme.colors.green1, width: '30px'}}
                className={style.OptionsIcon}
                src='/images/emojiSmile1.svg'/>
            : <SVG style={{'fill': Theme.colors.red1, width: '30px'}}
                className={style.OptionsIcon}
                src='/images/emojiUnhappy.svg'/>
        return (
            <Flex className={style.Post} column bg='grey1' w='100%'>
                <Flex>
                    <Flex className={style.Rating} w='50px'>
                    {emoji}
                    </Flex>
                    <Flex className={style.Date} hAlignContent='right'
                        color='lightblack' grow>
                        {date || '1970/01/01'}
                    </Flex>
                </Flex>
                <Flex className={style.FeedbackText} color='black'>
                    {text || ''}
                </Flex>
            </Flex>
        )
    }
}



// WEBPACK FOOTER //
// ./src/layout/Dashboard/RightPanel/ClientChatMenu/HelpDesk/RightPanel/PostHistory/Post/index.js